export default "__VITE_ASSET__d8106777__"